export class ErrorImageConvertUtility {
  /**
   * エラー検知時にparentElementをimgタグで書き換えるメソッド
   * @param currentTarget - エラーが発生した画像要素
   */
  public static convertErrorImage = (currentTarget: HTMLImageElement): void => {
    if (currentTarget && currentTarget.parentElement) {
      // imgタグを生成
      const imgElement = document.createElement('img');
      imgElement.src = currentTarget.src;
      imgElement.alt = currentTarget.alt || '';
      imgElement.className = currentTarget.className || '';
      imgElement.width = currentTarget.width || 0;
      imgElement.height = currentTarget.height || 0;

      // 親要素をimgタグで書き換える
      const { parentElement } = currentTarget;
      parentElement.innerHTML = '';
      parentElement.appendChild(imgElement);
    }
  };
}

export default ErrorImageConvertUtility;
